import { createErrorMessageTypeGuard } from '../createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { UnsavedCourseAssignment, CourseAssignment } from './@types';

export async function createCourseAssignment(
   assignment: UnsavedCourseAssignment,
   common: CommonRequestOptions = {}
): Promise<CourseAssignment> {
   return await makeRequest('post', 'course_assignments', {
      ...common,
      body: assignment,
   });
}

export type CreateCourseAssignmentErrorCode =
   | 'course_assignments.create.insufficent_privileges'
   | 'course_assignments.create.course_not_found'
   | 'course_assignments.create.course_disabled';

createCourseAssignment.errorMessages =
   createErrorMessageTypeGuard<CreateCourseAssignmentErrorCode>();
